// extracted by mini-css-extract-plugin
export var alignLeft = "H_rd d_fp d_bG d_dv";
export var alignCenter = "H_bP d_fq d_bD d_dw";
export var alignRight = "H_rf d_fr d_bH d_dx";
export var container = "H_mT d_dW d_Z";
export var containerFull = "H_sw d_dT d_Z";
export var images = "H_vv";
export var image = "H_vw d_w d_H d_bd d_0 d_8 d_7 d_4 d_9 d_dy";
export var imageWrapper = "H_rj";
export var design1 = "H_vx";